<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form @submit.prevent="searchFilter">
          <h6 class="heading-small text-muted mb-4">Search</h6>
          <div class="row">
            <div class="col">
              <a-input
                placeholder="Search by"
                v-model="search"
                @keyup.enter.prevent="setFilter"
              >
                <a-select
                  slot="addonAfter"
                  default-value="description"
                  style="width: 110px"
                  v-model="searchType"
                  @change="searchTypeOnChange"
                >
                  <a-select-option value="name">
                    <a-tooltip title="Name"> Name </a-tooltip>
                  </a-select-option>
                  <a-select-option value="description">
                    <a-tooltip title="Description"> Description </a-tooltip>
                  </a-select-option>
                  <a-select-option value="frequency_code">
                    <a-tooltip title="Frequency"> Frequency </a-tooltip>
                  </a-select-option>
                </a-select>
              </a-input>
            </div>
          </div>
          <hr />
          <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
          <div class="row mb-3">
            <div class="col">
              <a-select
                v-model="table.filters.status_code"
                show-search
                mode="multiple"
                optionFilterProp="children"
              >
                <a-select-option value="N"> Not Started </a-select-option>
                <a-select-option value="A"> Active </a-select-option>
                <a-select-option value="C"> Completed </a-select-option>
              </a-select>
            </div>
          </div>
          <br />
          <div>
            <div>
              <h6 class="heading-small text-muted mb-4">
                Filter By Membership Program
              </h6>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.filters.membership_program_id"
                  show-search
                  optionFilterProp="children"
                >
                  <a-select-option :value="null"> All </a-select-option>
                  <a-select-option
                    v-for="membershipProgram in membershipPrograms"
                    :key="membershipProgram.id"
                    :value="membershipProgram.id"
                    :label="membershipProgram.name"
                  >
                    {{ membershipProgram.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <base-button
                type="primary btn-block"
                class="my-4"
                @click.prevent="setFilter"
              >
                <div>Apply Filter</div>
              </base-button>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :api-url="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :sortOrder="table.sortOrder"
          @doneLoading="doneLoadingTable"
        >
          <template #headerButtons>
            <base-button
              v-if="selectedActions.includes('Add')"
              id="new"
              class="float-right ml-1"
              type="primary"
              size="sm"
              @click="openDrawer()"
              >+ Add Scratch Card</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <ScratchCardForm
                :viewMode="viewMode"
                :scratchCardData="scratchCardData"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <button
              v-if="selectedActions.includes('View')"
              id="view"
              class="btn btn-success btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>
            <button
              v-if="selectedActions.includes('Edit')"
              id="edit"
              class="btn btn-warning btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Edit
            </button>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import ScratchCardForm from './ScratchCardForm.vue';
import HTTPRequest from '../../controllers/httpRequest';
import tokenHandler from '../../controllers/token';
import secureStorage from '../../controllers/secureStorage';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment-timezone';
export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    ScratchCardForm
  },
  data() {
    return {
      tableRowsLength: 0,
      tableCurPage: 0,
      searchType: 'name',
      search: null,
      gradientType: 'gradient-purple',
      scratchCardData: null,
      drawer: {
        visible: false,
        width: 1200,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Scratch Card',
        apiUrl: '/api/v1/account_games',
        fields: [
          'actions',
          { name: 'game_code', title: 'Code' },
          { name: 'name', title: 'Name' },
          { name: 'description', title: 'Description' },
          {
            name: 'status',
            title: 'Status',
            formatter(status) {
              let display = status;
              switch (status) {
                case 'A':
                  display =
                    '<button class="btn btn-info btn-sm" disabled>Active</button>';
                  break;
                case 'C':
                  display =
                    '<button class="btn btn-success btn-sm" disabled>Completed</button>';
                  break;
                case 'N':
                  display =
                    '<button class="btn btn-danger btn-sm" disabled>Not Started</button>';
                  break;
                default:
                  display = status;
              }
              return display;
            }
          },
          // { name: 'claim_limit', title: 'Claim Limit' },
          {
            name: 'frequency_code',
            title: 'Frequency',
            formatter(frequency) {
              return _.startCase(_.toLower(frequency));
            }
          },
          {
            name: 'created_at',
            title: 'Created Date',
            formatter(date) {
              if (moment(date).isValid()) {
                return moment(date).format('MM/DD/YYYY');
              }
              return null;
            }
          }
        ],
        filters: {
          game_type_code: 'SCR_CD',
          membership_program_id: null,
          status_code: ['A']
        },
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ]
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  async created() {
    this.$store.dispatch('setCurrentModule', 'ScratchCard');
    // await this.getMembershipPrograms();
  },
  async mounted() {
    if (secureStorage.getItem('uploadToken') === null) {
      await tokenHandler.refreshS3Token();
    }
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions',
      membershipPrograms: 'membershipPrograms'
    })
  },
  methods: {
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.options.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    doneLoadingTable(response) {
      this.tableRowsLength = response.data.length;
      this.tableCurPage = response.current_page;
    },
    searchTypeOnChange(val) {
      let types = ['name', 'description', 'frequency_code'];
      let index = types.indexOf(val);
      if (index !== -1) {
        types.splice(index, 1);
      }
      let x = 0;
      while (x < types.length) {
        if (Object.hasOwn(this.table.filters, types[x])) {
          delete this.table.filters[types[x]];
        }
        x++;
      }
      this.table.filters[this.searchType] = this.search;
    },
    openDrawer(rowData = null) {
      this.viewMode = event.target.id == 'view' ? true : false;
      this.scratchCardData = rowData;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.scratchCardData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    },

    async deleteRow(rowData) {
      const messageId = rowData.id;
      const response = await HTTPRequest.deleteRequest(
        `/api/v1/account_games/${messageId}`
      );

      if (response.message == 'Success') {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    },
    searchFilter() {
      this.table.filters[this.searchType] = this.search;
      this.setFilter();
    }
  },
  watch: {
    search(val) {
      if (val == '') this.search = null;
      this.table.filters[this.searchType] = val;
    }
  }
};
</script>

<style scoped></style>
